import { renderPercentChange } from "modules/Shopify_dashboard/helper";
import React from "react";

const MonthComparisonCards = ({ data }) => {
  const stats = [
    {
      label: "Total Order Value",
      current: data?.currentData?.totalOrderValue,
      previous: data?.previousData?.totalOrderValue,
    },
    {
      label: "Male Total Value",
      current: data?.currentData?.male?.totalValue,
      previous: data?.previousData?.male.totalValue,
    },
    {
      label: "Male Repeat Value",
      current: data?.currentData?.male?.repeatValue,
      previous: data?.previousData?.male.repeatValue,
    },
    {
      label: "Male New Value",
      current: data?.currentData?.male?.newValue,
      previous: data?.previousData?.male.newValue,
    },
    {
      label: "Female Total Value",
      current: data?.currentData?.female?.totalValue,
      previous: data?.previousData?.female.totalValue,
    },
    {
      label: "Female Repeat Value",
      current: data?.currentData?.female?.repeatValue,
      previous: data?.previousData?.female.repeatValue,
    },
    {
      label: "Female New Value",
      current: data?.currentData?.female?.newValue,
      previous: data?.previousData?.female?.newValue,
    },
  ];

  return (
    <div className="d-flex flex-wrap gap-3 p-3">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className={`card shadow-sm p-3 d-flex flex-column rounded-3 cursor-pointer transition-all duration-300`}
          style={{
            width: "200px",
            backgroundColor: "#fff",
            border: "1px solid #ddd",
          }}
        >
          <div className="fw-bold mb-2">{stat?.label}</div>
          <div className="fw-bold d-flex flex-row gap-2 text-dark mb-2 text-nowrap">
            <div className="d-flex flex-column">
              <span>₹{stat?.current?.toLocaleString()} </span>
              <span className="fw-semibold text-muted">
                ₹{stat?.previous?.toLocaleString()}
              </span>
            </div>
            <div
              className="ms-2"
              style={{
                color: stat?.current >= stat?.previous ? "green" : "red",
                fontWeight: "bold",
              }}
            >
              {renderPercentChange(stat?.current, stat?.previous)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MonthComparisonCards;
